import { render, staticRenderFns } from "./VlIndexCheckbox.vue?vue&type=template&id=37004eb4&scoped=true&"
import script from "./VlIndexCheckbox.vue?vue&type=script&lang=js&"
export * from "./VlIndexCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37004eb4",
  null
  
)

export default component.exports